import { jacyzHotel } from './jacyz-hotel';
import { hjortvikenHotel } from './hjortviken-hotel';
import { hotelPigalle } from './hotel-pigalle';
import { hotelBellora } from './hotel-bellora';
import { villaJohanneberg } from './villa-johanneberg';
import { roxResort } from './rox-resort';
import { steamHotel } from './steam-hotel';
import { fyriResort } from './fyri-resort';
import { maryhillEstate } from './maryhill-estate';
import { mjsMalmo } from './mjs-malmo';
import { ystadSaltsjobad } from './ystad-saltsjobad';
import { elleryBeachHouse } from './ellery-beach-house';
import { falkenbergStrandbad } from './falkenberg-strandbad';
import type { Venue } from '../../types/venue';

export const venues: Venue[] = [
  jacyzHotel,
  hjortvikenHotel,
  hotelPigalle,
  hotelBellora,
  villaJohanneberg,
  roxResort,
  steamHotel,
  fyriResort,
  maryhillEstate,
  mjsMalmo,
  ystadSaltsjobad,
  elleryBeachHouse,
  falkenbergStrandbad
];